import React from 'react';
import Mixpanel from 'helpers/Mixpanel.js';
import { AutoGrid } from '@bit/knotchinc.web-react-components.grid';
import { REPORT_GRID_STYLE, findMaxItems, calculateRowHeight } from 'components/Pages/Reports/helpers.js';
import EntityItem from 'components/Global/EntityItem/EntityItem.jsx';
import { ListTitle, Section } from 'components/Pages/Reports/styled.js';
import EntityListCard from 'components/Pages/Reports/EntityListCard.jsx';
import ReportLeaderboard from 'components/Pages/Reports/ReportLeaderboard/ReportLeaderboard.jsx';
import EntityOverview from 'components/Pages/Reports/EntityOverview/EntityOverview.jsx';
import { EntityKeywordsStatsRow } from 'components/Pages/Reports/EntityOverview/rows';
import ReportErrorTab from './ReportErrorTab.jsx';

const BrandsReportTab = ({ report: {
      public_id,
      brands: {
      top_brands_by_num_contents,
      publishers_by_common_brands,
      top_brands_by_publishers,
      error,
    },
    request,
  },
 }) => {
  if (error) {
    return (<ReportErrorTab error={error} request={request} />);
  }

  Mixpanel.track('viewed Brands Report Tab', { report_id: public_id });
  const { report_type: reportType } = request;
  const maxEntities = findMaxItems(publishers_by_common_brands, 'resources');
  const rowHeight = calculateRowHeight(maxEntities, 'entity');

  const CommonPublishers = AutoGrid({
    rowHeight,
    cols: publishers_by_common_brands.map(({ entity, resources }) =>
      <EntityListCard title={<EntityItem data={entity} />} resources={resources} />),
    colsPerRow: 3,
    gridStyle: REPORT_GRID_STYLE,
  });
  const RowComponent = props => (<EntityKeywordsStatsRow reportType={reportType} {...props} />);

  return (
    <React.Fragment>
      <Section>
        <ListTitle>TOP SHARED BRANDS</ListTitle>
        <ReportLeaderboard type="entity" reportType={reportType} data={top_brands_by_num_contents} />
      </Section>
      <Section>
        <ListTitle>TOP 5 BRANDS ACROSS PUBLISHERS</ListTitle>
        <CommonPublishers />
      </Section>
      <Section>
        <ListTitle>MOST USED BRANDS BY PUBLISHER</ListTitle>
        <EntityOverview data={top_brands_by_publishers} Row={RowComponent} type="entity" entityType={reportType} />
      </Section>
    </React.Fragment>);
};


export default BrandsReportTab;
